import { render } from "./TransactionItem.vue?vue&type=template&id=349aa594&scoped=true&ts=true"
import script from "./TransactionItem.vue?vue&type=script&lang=ts"
export * from "./TransactionItem.vue?vue&type=script&lang=ts"

import "./TransactionItem.vue?vue&type=style&index=0&id=349aa594&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-349aa594"]])

export default __exports__